import { NgModule } from '@angular/core';
import { DataLayer } from './datalayer';

@NgModule({
  providers: [DataLayer]
})
export class DataLayerModule {}
